import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

// Resolve the current company's logo to a usable <img>/<Avatar> src.
//
// The /api/company/logo/download endpoint requires the auth token (it routes to
// the tenant's own database), which a plain <img src> request cannot send — so
// it 401s. Instead we fetch the image as a blob WITH the Authorization header
// and hand back an object URL. Falls back to the legacy logoUrl, or '' when the
// company has no logo. The object URL is revoked on cleanup / when it changes.
//
// Re-fetches when the stored logo changes (logoFileName/updatedAt), so a freshly
// uploaded logo shows immediately.
export default function useCompanyLogo(company) {
  const [src, setSrc] = useState('');

  const hasFile   = !!(company && (company.logoData || company.logoFileName));
  const legacyUrl = (company && company.logoUrl) || '';
  const version   = `${company?.logoFileName || ''}|${company?.updatedAt || ''}`;

  useEffect(() => {
    let cancelled = false;
    let objectUrl = '';

    if (hasFile) {
      axios.get(`${API}/api/company/logo/download`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      })
        .then(res => {
          if (cancelled) return;
          objectUrl = URL.createObjectURL(res.data);
          setSrc(objectUrl);
        })
        .catch(() => { if (!cancelled) setSrc(''); });
    } else {
      setSrc(legacyUrl);
    }

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [hasFile, legacyUrl, version]);

  return src;
}
